var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "home-container" }, [
    _c(
      "div",
      { staticClass: "hx-breadcrumb" },
      [
        _c(
          "el-breadcrumb",
          { attrs: { "separator-class": "el-icon-arrow-right" } },
          [
            _c("el-breadcrumb-item", [_vm._v("疗养预约系统")]),
            _c("el-breadcrumb-item", [_vm._v("疗养院管理")]),
            _c("el-breadcrumb-item", [_vm._v("新增疗养院")]),
          ],
          1
        ),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "hx-form-container box-shadow" },
      [
        _c(
          "el-form",
          {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.tableLoading,
                expression: "tableLoading",
              },
            ],
            attrs: { model: _vm.listParams, rules: _vm.checklistParams },
          },
          [
            _c(
              "el-form-item",
              { attrs: { label: "名称：" } },
              [
                _c("el-input", {
                  staticStyle: { width: "200px" },
                  attrs: { size: "small", placeholder: "输入名称" },
                  model: {
                    value: _vm.listParams.name,
                    callback: function ($$v) {
                      _vm.$set(_vm.listParams, "name", $$v)
                    },
                    expression: "listParams.name",
                  },
                }),
              ],
              1
            ),
            _c(
              "el-form-item",
              { attrs: { label: "地址：" } },
              [
                _c("el-input", {
                  staticStyle: { width: "200px" },
                  attrs: { size: "small", placeholder: "输入地址" },
                  model: {
                    value: _vm.listParams.detailAddress,
                    callback: function ($$v) {
                      _vm.$set(_vm.listParams, "detailAddress", $$v)
                    },
                    expression: "listParams.detailAddress",
                  },
                }),
              ],
              1
            ),
            _c(
              "el-form-item",
              {
                staticClass: "align-center mgt10",
                staticStyle: { "padding-bottom": "20px", "margin-top": "20px" },
              },
              [
                _c(
                  "el-button",
                  {
                    attrs: { size: "small", type: "primary" },
                    on: {
                      click: function ($event) {
                        return _vm.saveAdd()
                      },
                    },
                  },
                  [_vm._v(" 保存 ")]
                ),
                _c(
                  "el-button",
                  {
                    staticClass: "mgl20",
                    attrs: { size: "small" },
                    on: { click: _vm.backToList },
                  },
                  [_vm._v("返回")]
                ),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }